// extracted by mini-css-extract-plugin
export default {"btnSubMenu":"MasterSale_btnSubMenu__w78NA"};